<template>
    <div class="part-container">
      <!-- 头部 -->
      <div class="part-header">
      
        <div class="header-title ">相关活动</div>  <!-- content-white -->
        <div class="header-more " @click="handleMore"><span class="plus">+</span>&nbsp;&nbsp;更多</div>  <!-- content-white -->
      </div>
  
      <!-- 内容列表 -->
      <div class="list-content">
        <div
          v-for="(item, index) in displayItems"
          :key="index"
          class="part-item"
          @click="handleItemClick(item)"
        >
            <!-- <img src="/assets/~/media/images/ai/activity-icon.png" alt="活动icon" class="item-icon"> -->
            <div class="item-info">
                <div class="item-title">{{ item.title }}</div>
                <div class="item-content">{{ item.description }}</div>
            </div>
        </div>
      </div> 
    </div>
  </template>
  
  <script>
  export default {
    name: 'DetailList',
    props: {
      // 头部标题
      title: {
        type: String,
        required: true,
      },
      // 数据列表
      list: {
        type: Array,
        default: () => [],
      },
      // 最大显示数量
      maxItems: {
        type: Number,
        default: 12,
      },
      // 是否展开状态
      isExpanded: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        // 移除本地的isExpanded状态，使用props中的值
      };
    },
    computed: {
      // 是否显示展开按钮
      showExpandButton() {
        return this.list.length > 1;
      },
      // 当前显示的条目数量
      currentItemCount() {
        if (!this.isExpanded) {
          return Math.min(1, this.list.length); // 未展开时显示第1个
        }
        return Math.min(3, this.list.length); // 展开时显示前3个
      },
      // 当前显示的条目
      displayItems() {
        return this.list.slice(0, this.currentItemCount);
      },
    },
    methods: {
      // 处理条目点击
      handleItemClick(item) {
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), 'question-Details-多模态-相关活动： '+ item.title, 1]);
        stm_clicki("send",'event',window.location.href, "点击", 'question-Details-多模态-相关活动： '+ item.title);
        if (item.url) {
          //打开新网页链接
          window.open(item.url);
        }
      },
      
      // 处理更多按钮点击
      handleMore() {
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), 'question-Details-多模态-相关活动-更多', 1]);
        stm_clicki("send",'event',window.location.href, "点击", 'question-Details-多模态-相关活动-更多');
        // 触发父组件事件
        this.$emit('more-click','activity');
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  @import './style/part.css';
  .part-header {
    width: calc((373 / 413) * 100%);
    margin: calc((20 / 413) * 100%) auto calc((12 / 413) * 100%) auto;
    padding: 0;
  }
  .header-more {
    display: inline-flex;
    align-items: center;
    line-height: 1;
  }
  .header-more {
    background-color:#CDD0D251// rgba(255, 255, 255, 0.2);
  }
  .header-more:hover {
    background-color: #CDD0D277//rgba(255, 255, 255, 0.3);
  }
  .header-more .plus {
    font-size: calc((18 / 1920) * 100vw); /* 加号稍微大一点 */
    display: inline-block;
    transform: translateY(calc((0 / 1920) * 100vw)); /* 微调视觉对齐 */
  }
  .part-container {
    height: 100%;
  }
  /* activity.vue 特定样式 */
  .list-content {
    width: calc((373 / 413) * 100%); /* 宽度比例为 373:413 */
    margin: 0 auto; /* 左右居中 */
    // padding: 0 calc(15 / 1920 * 100vw); /* 添加左右内边距 */
    
  }
  .part-item:hover {
    background-color: rgba(255, 255, 255, 0.3);
  }
  .part-item {
    width: 100%; /* 宽度为100% */
    height: calc((93 / 1920) * 100vw);
    // height: calc((93 / 413) * 100%);
    // aspect-ratio: 373 / 93; /* 高度和宽度之比为 93:373 */
    background-color:#ffffff;// rgba(255, 255, 255, 0.2);
    overflow: hidden;
    border-radius: calc((12 / 1920) * 100vw);
    padding: calc((16 / 413) * 100%) 0;
    display: flex;
    align-items: center;
    gap: calc((20 / 413) * 100%);
    margin-bottom: calc((15 / 413) * 100%);
    .item-icon {
      //  height: 100%;
      height: calc((93 / 1920) * 100vw - calc((32 / 1920) * 100vw));
      width: calc((93 / 1920) * 100vw - calc((32 / 1920) * 100vw));
        object-fit: contain;
        margin-left: calc((16 / 413) * 100%);
    }
    .item-info {
        height: 100%;
        padding: calc((7 / 413) * 100%) calc((20 / 413) * 100%) calc((7 / 413) * 100%) 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        /* 允许在 flex 布局中子项宽度可收缩以启用省略号 */
        min-width: 0;
        margin-left:  calc((20 / 413) * 100%);
    }
    .item-title {
        font-size: calc((16 / 1920) * 100vw);
        font-family: 'FZLanTingHeiS-B-GB';
        color: #000;//#fff;
        /* 单行省略号 */
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
    }
    .item-content {
        font-size: calc((14 / 1920) * 100vw);
        font-family: 'FZLanTingHeiS-R-GB';
         color: #000;//#fff;
        /* 单行省略号 */
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
        line-height: 1.2;
    }
  }
  </style>
  